
const isBrowser = () =>
  typeof window !== "undefined" || (process as any).browser;

export const getApiUrl = () => {
  if (
    isBrowser()
    && typeof window !== "undefined"
    && window != null
    && window.location != null
    && window.location.origin != null
    && process.env.PROJECT_TYPE !== "browser-extension"
  ) {
    return window.location.origin;
  } else if (process.env.API_URL) {
    return process.env.API_URL;
  }

  const NEXT_PUBLIC_VERCEL_URL = process.env?.VERCEL_URL ?? process.env?.NEXT_PUBLIC_VERCEL_URL ?? undefined;

  if (NEXT_PUBLIC_VERCEL_URL) {
    return `https://${NEXT_PUBLIC_VERCEL_URL}`;
  }

  return process.env.BASE_URL;
};

export const getBaseUrl = () => {
  if (
    isBrowser()
    && typeof window !== "undefined"
    && window != null
    && window.location != null
    && window.location.origin != null
    && process.env.PROJECT_TYPE !== "browser-extension"
  ) {
    return window.location.origin;
  } else if (process.env.BASE_URL) {
    return process.env.BASE_URL;
  }
  /*
    getBaseUrl should only be used when we need to provide a URL to a third party app,
    so they redirect back to the correct place. Everything else should use API_BASE_URL
   */

  return process.env.BASE_URL;
};

export const NO_CACHE_HEADERS = {
  "Cache-Control": "no-cache, no-store, must-revalidate"
};